module.exports = __webpack_public_path__ + "img/sec-image.9ce8092a.png";